import { FC, useState } from "react";
import { useFormState } from "react-final-form";

import { Dialog } from "@bps/fluent-ui";
import { ClaimAdjustmentStatus } from "@libs/gateways/acc/AccGateway.dtos.ts";
import { useClaimAdjustmentContext } from "@modules/acc/screens/claim-adjustment/context/ClaimAdjustmentContext.ts";
import { ClaimAdjustmentFormValues } from "@shared-types/acc/claim-adjustment-form-values.type.ts";
import { FormStatusIndicatorBadge } from "@ui-components/form/FormStatusIndicator/FormStatusIndicatorBadge.tsx";

import { ClaimAdjustmentStatusBadge } from "../ClaimAdjustmentStatusBadge.tsx";

export const ClaimAdjustmentOverviewBadge: FC = () => {
  const {
    claimAdjustment,
    isClaimAdjustmentFormReady,
    isVerballyApprovedClaimAdjustmentReady,
    validateClaimAdjustmentForm
  } = useClaimAdjustmentContext();

  const { values } = useFormState<ClaimAdjustmentFormValues>();
  const [showDialog, setShowDialog] = useState(false);

  const status =
    claimAdjustment.status?.code ?? ClaimAdjustmentStatus.Incomplete;

  if (
    status === ClaimAdjustmentStatus.Incomplete ||
    status === ClaimAdjustmentStatus.Ready
  ) {
    const valid = claimAdjustment.verballyApproved
      ? isVerballyApprovedClaimAdjustmentReady(values)
      : isClaimAdjustmentFormReady(values);

    const onClick = () => {
      if (!valid) {
        setShowDialog(true);
      }
    };

    /* A dialog has been temporary added to this component to display the form errors to the user
        This is because we have a bug where the form appears fully filled out but the form still
        can't be submitted.  The purpose of this dialog is for the user to be able to show us so
        we can further debug the problem.  Then the dialog will have served its purpose and can
        be removed   
    */
    const errors = validateClaimAdjustmentForm(values) ?? {};

    return (
      <div onClick={onClick}>
        <FormStatusIndicatorBadge valid={valid} />
        <Dialog
          onDismiss={() => setShowDialog(false)}
          hidden={!showDialog}
          minWidth={600}
          dialogContentProps={{
            title: "Claim adjustment form debug"
          }}
        >
          <div>
            Is verbally approved: {String(!!claimAdjustment.verballyApproved)}
          </div>
          {Array.from(Object.entries(errors)).map(([key, value]) => {
            if (!value || value === "{}") return null;
            return (
              <div
                key={key}
                style={{ textWrap: "wrap", wordWrap: "break-word" }}
              >
                {String(key)}: {JSON.stringify(value)}
              </div>
            );
          })}
        </Dialog>
      </div>
    );
  }

  return <ClaimAdjustmentStatusBadge code={status} />;
};
